const slugify = (input: string): string =>
  input.toLowerCase().trim().replaceAll(' ', '_');

export default slugify;
